const PedidosActionTypes = {
  DADOSGERAIS: "pedidos/dadosGerais",
  DADOSALIMENTOS: "pedidos/dadosAlimentos",
};

export default PedidosActionTypes;
